module.exports = __webpack_public_path__ + "img/inst-modal-14.35373388.png";